<template>
  <div class="page-main">
    <top-header></top-header>
    <div class="content-wrapper">
      <left-menu></left-menu>
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
    <div style="display: none;" ref="workbench" id="ccbar"></div>
  </div>
</template>

<script>
import TopHeader from "./TopHeader";
import LeftMenu from "./LeftMenu";

export default {
  components: { TopHeader, LeftMenu },
  methods: {
    destroyWorkbench() {
      if (callByAli) {
        let workbench = window.workbench;
        if (workbench) {
          let rst = workbench.getStatusCode();
          let code = rst.code;
          if (code === 3 || code === 2 || code === 5) {
            workbench.logOut();
          } else if (code === 8 || code === 9 || code === 10 || code === 21) {
            workbench.hangUp();
          }
        }
      } else {
        let code = CallControl.getState();
        if (code == "IDLE" || code == "BUSY" || code == "WORKNOTREADY") {
          CallControl.logoff(function (result) {
            try {
              if (result.state != "1") {
                tipsMsg(result.msg);
              }
            } catch (e) {}
          });
        } else if (code == "TALK" || code == "MONITORED") {
          CallControl.clearCall();
        }
      }
    },
  },
  mounted() {
    // 如果不是工作台,则需要初始化坐席
    this.Service.call("callcenter/getInitial", "GET", {
      userId: this.$store.state.auth.userGid,
    }).then((data) => {
      localStorage.setItem("initialInfo", JSON.stringify(data));
      this.$store.commit("setInitialInfo", data);
      this.$store.dispatch("initWorkbench");
      this.$refs.workbench.remove();
    });
    let workbench = window.workbench;
    if (callByAli) {
      if (workbench && workbench.getStatusCode().code === 1) {
        workbench.logIn();
      }
    } else {
      console.log("qqq:" + CallControl.getState());
      if (
        CallControl.getState() == null ||
        CallControl.getState() === "LOGOFF"
      ) {
        // ccbarsdk.logon("8002@jygjjyl", b64_md5("1234qwer"), "115097310138001", function(result) { console.log("111111111111111") }); //坐席工号,MD5加密的密码,话机号码
      }
    }
  },
  watch: {
    "$store.state.auth"(val) {
      if (!val) {
        this.destroyWorkbench();
      }
    },
  },
  beforeDestroy() {
    this.destroyWorkbench();
  },
};
</script>
